<template>
	<div>
	<div v-show="!showRecord">
		<a-spin :spinning="loading">
			<a-form ref="form" :model="formState" name="form" @finish="onSearch">
				<a-row>
					<a-form-item class="ui-form__item" name="organizationId" label="影院组织">
						<a-select placeholder="请选择" v-model:value="formState.organizationId" style="width: 250px;"
							@change="getAllCinemaList">
							<!-- <a-select-option :value="0">全部</a-select-option> -->
							<a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
								{{ item.name }}</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item class="ui-form__item" name="cinemaId" label="开卡影院">
						<a-select placeholder="请选择" v-model:value="formState.cinemaId" style="width: 250px;">
<!--              <a-select placeholder="请选择" v-model:value="formState.cinemaId" style="width: 250px;"
                        @change="getCardPolicyList">-->
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
								{{ item.name }}</a-select-option>
						</a-select>
					</a-form-item>
				</a-row>
				<a-row v-show="showAll">
          <a-form-item label="是否一卡通" name="isOneCard" class="ui-form__item">
            <a-select v-model:value="formState.isOneCard" style="width: 180px;" placeholder="请选择状态">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="ui-form__item" name="useCinemaId" label="可用影院">
            <a-select placeholder="请选择" v-model:value="formState.useCinemaId" style="width: 250px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
					<a-form-item label="会员昵称" name="memberName" class="ui-form__item">
						<a-input v-model:value="formState.memberName" placeholder="请输入会员昵称"></a-input>
					</a-form-item>

					<a-form-item label="会员手机" name="memberPhone" class="ui-form__item">
						<a-input v-model:value="formState.memberPhone" placeholder="请输入会员手机"></a-input>
					</a-form-item>

					<a-form-item label="线上会员卡号" name="cardNumber" class="ui-form__item">
						<a-input v-model:value="formState.cardNumber" placeholder="请输入线上会员卡号"></a-input>
					</a-form-item>

					<a-form-item label="线上会员卡等级" name="cardTitle" class="ui-form__item">
            <a-input v-model:value="formState.cardTitle" placeholder="请输入线上会员卡等级"></a-input>
					</a-form-item>

          <a-form-item class="ui-form__item" name="isNeverExpire" label="是否永久有效" style="width: 250px">
            <a-select placeholder="请选择" v-model:value="formState.isNeverExpire">
              <a-select-option value="0">否</a-select-option>
              <a-select-option value="1">是</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="有效结束时间" class="ui-form__item">
            <a-range-picker v-model:value="endTime"></a-range-picker>
          </a-form-item>
				</a-row>

				<a-row>
					<a-col :span="18">
						<span v-permission="['coupon_stored_info_export']">
							<exportComponent type="baseRechargeCard" :searchData="searchData"></exportComponent>
						</span>
            <a-button v-permission="['coupon_stored_info_delay']" style="margin-left: 20px" @click="onSelectBatchDelay" :disabled="!selectedListData.length">批量延期</a-button>
            <a-button v-permission="['coupon_stored_info_delay']" style="margin-left: 20px" @click="onBatchDelay">文件批量延期</a-button>

						<a style="margin-left: 20px;" @click="showAll = !showAll">
							{{ showAll ? '收起' :'展开' }}
							<Icon v-show="!showAll" icon="DownOutlined"></Icon>
							<Icon v-show="showAll" icon="UpOutlined"></Icon>
						</a>
					</a-col>
					<a-col :span="6" style="text-align: right;">
						<a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
						<a-button @click="reset">重置</a-button>
					</a-col>
				</a-row>
			</a-form>

			<div style="margin-top: 20px;">
				<a-table :pagination="pagination" :columns="columns" :dataSource="list" rowKey="id"
          :rowSelection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onSelect: onSelectChange, onSelectAll: onSelectAll, getCheckboxProps: getCheckboxProps }"
					:scroll="{ x: 1800 }">
					<template #bodyCell="{ column, record }">
						<template v-if="column.key === 'userInfo'">
							<div>会员昵称：{{ record.memberName || '-' }}</div>
							<div>会员手机：{{ record.memberPhone || '-' }}</div>
						</template>
						<template v-if="column.key === 'isDisabled'">
							{{ record.isDisabled ? '已禁用' : '已启用' }}
						</template>
						<template v-else-if="column.key === 'createTime'">
							<div>{{ transDateTime(record.createTime) }}</div>
						</template>
            <template v-if="column.key === 'isOneCard'">
              <span>{{ record.isOneCard == 1 ? '是' : '否' }}</span>
            </template>
            <template v-if="column.key === 'cinemaNames'">
              <span>{{ record.isOneCard == 1 ? '全部影院' : record.cinemaNames }}</span>
            </template>
            <template v-if="column.key === 'expireTime'">
              <div>{{ record.isNeverExpire == 1 ? '永久有效' : (transDateTime(record.startTime, 1)  + '~' + transDateTime(record.expireDate, 1) ) }}</div>
            </template>
						<template v-else-if="column.key === 'action'">
							<a-dropdown :trigger="['click', 'hover']">
								<a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
								</a-button>
								<template #overlay>
									<a-menu>
										<div v-permission="['coupon_stored_info_disabled']"
											v-if="record.isDisabled === 0" @click="onDisabled(record)">
											<a-menu-item>
												禁用
											</a-menu-item>
										</div>
										<div v-permission="['coupon_stored_info_open']" v-else
											@click="onDisabled(record)">
											<a-menu-item>
												启用
											</a-menu-item>
										</div>
										<div v-permission="['coupon_stored_info_modify']"
											@click="onModifyBalance(record)">
											<a-menu-item>
												充值金额
											</a-menu-item>
										</div>
										<div v-permission="['coupon_stored_info_record']" @click="onRecord(record)">
											<a-menu-item>充值记录</a-menu-item>
										</div>
										<div v-permission="['coupon_stored_info_unbind']" @click="onUnbind(record)">
											<a-menu-item>解绑</a-menu-item>
										</div>
                    <div
                      @click="onChangeCinema(record)">
                      <a-menu-item>
                        修改开卡影院
                      </a-menu-item>
                    </div>
<!--                    <div @click="onCardDelay(record)" v-if="record.expireDate" v-permission="['coupon_stored_info_delay']">-->
                    <div @click="onCardDelay(record)" v-if="!record.isNeverExpire" v-permission="['coupon_stored_info_delay']">
                      <a-menu-item>
                        延期
                      </a-menu-item>
                    </div>
									</a-menu>
								</template>
							</a-dropdown>
						</template>
					</template>
				</a-table>
			</div>

			<a-modal title="修改线上会员卡余额" width="600px" v-model:visible="showModal" @cancel="onModifyCancel"
				@ok="onModifyOk">
				<a-spin :spinning="loading">
					<a-form ref="modifyForm" name="modifyForm" :model="modelRef" :labelCol="{ span: 6 }"
						:wrapperCol="{ span: 14 }">
						<a-form-item label="本金余额">
							{{ modifyItem.balance || 0 }} 元
						</a-form-item>

            <a-form-item label="本金充值金额" name="balance" :rules="[{required: true, message: '必填项不允许为空'}]">
              <a-input-number v-model:value="modelRef.balance" :min="'-' + modifyItem.balance" :precision="2" placeholder="请输入">
              </a-input-number> 元
            </a-form-item>

            <a-form-item label="充值后金额">
              {{ (modifyItem.balance + (modelRef.balance || 0)).toFixed(2) }} 元
            </a-form-item>

            <a-divider></a-divider>

            <a-form-item label="赠送余额">
              {{ modifyItem.giftBalance || 0 }} 元
            </a-form-item>

            <a-form-item label="赠送余额充值金额" name="giftAmount" :rules="[{required: true, message: '必填项不允许为空'}]">
              <a-input-number v-model:value="modelRef.giftAmount" :min="'-' + modifyItem.balance" :precision="2" placeholder="请输入">
              </a-input-number> 元
            </a-form-item>

            <a-form-item label="充值后金额">
              {{ (modifyItem.giftBalance + (modelRef.giftAmount || 0)).toFixed(2) }} 元
            </a-form-item>

					</a-form>
				</a-spin>
			</a-modal>
		</a-spin>
	</div>
		<Recharge v-if="showRecord" :id="id" @back="onBack"></Recharge>
    <a-modal v-model:visible="setChangeCinema" destroyOnClose width="700px" title="修改开卡影院" @ok="onChangeCinemaOk">
      <a-spin :spinning="loading">
        <a-form ref="setCinemaForm" name="setCinemaForm" :model="cinemaModelRef" :labelCol="{span: 6}" :wrapperCol="{span: 14}">
          <a-form-item label="修改影院">
            <a-select placeholder="请选择" v-model:value="cinemaModelRef.cinemaId" style="width: 250px;">
              <a-select-option v-for="item in editCinema" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
<!--    TODO 处理结束日期-->
    <a-modal v-model:visible="setDelayVisible" width="800px" destroyOnClose title="线上会员卡延期" @ok="onDelayOk"
             @cancel="onDelayCancel">
      <a-spin :spinning="loading">
        <a-form ref="delayForm" name="delayForm" :model="delayModelRef" :labelCol="{span: 5}"
                :wrapperCol="{span: 16}">
          <div v-if="!setSelectBatchDelayVisible">
            <a-form-item label="会员账号">{{ setRecordData.memberPhone }}</a-form-item>
            <a-form-item label="线上会员卡号">{{ setRecordData.cardNumber }}</a-form-item>
            <a-form-item label="有效时间" v-if="setRecordData.expireDate">
              <p>{{ transDateTime(setRecordData.expireDate, 1) }}</p>
              <p style="color: red" v-if="setRecordData.lossExpireDate">缺失有效期, 默认从今天开始算重置日期</p>
            </a-form-item>
          </div>

          <a-form-item label="快捷选择" name="setValue" :rules="[{required: true, message: '必选项不允许为空'}]">
            <a-radio-group v-model:value="delayModelRef.setValue" button-style="solid">
              <a-radio-button :value="1">1天</a-radio-button>
              <a-radio-button :value="2">7天</a-radio-button>
              <a-radio-button :value="3">3月</a-radio-button>
              <a-radio-button :value="4">6月</a-radio-button>
              <a-radio-button :value="5">1年</a-radio-button>
              <a-radio-button :value="6">自定义日期</a-radio-button>
              <a-radio-button :value="7">自定义时间</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <div>
            <a-form-item v-if="delayModelRef.setValue === 6" label="延期至" name="specifiesTime"
                         :rules="[{required: true, message: '必选项不允许为空'}]">
              <a-date-picker :disabled-date="disabledDate" v-model:value="delayModelRef.specifiesTime" />
              <p style="margin-top: 6px;color: #666;">需大于今天才会生效</p>
            </a-form-item>
            <a-form-item v-else-if="delayModelRef.setValue === 7" label="延期至" name="delayDays"
                         :rules="[{required: true, message: '必选项不允许为空'}]">
              <a-input-number v-model:value="delayModelRef.delayDays" :min="0" :precision="0"
                              placeholder="请输入"></a-input-number>
              <span style="padding-left: 8px;">天</span>
            </a-form-item>
            <a-form-item v-else-if="!setSelectBatchDelayVisible" label="延期至">
              <span>{{ transDateTime(delayEndTime(setRecordData.expireDate), 1) }}</span>
            </a-form-item>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
    <a-modal v-model:visible="setBatchDelayVisible" width="500px" destroyOnClose title="线上会员卡批量延期" @ok="onBatchDelayOk" @cancel="onBatchDelayCancel"
             :footer="null">
      <a-form ref="fileDelayRef" name="fileDelayRef">
        <a-form-item label="文件">
          <a-upload v-model:file-list="delayFileList" list-type="picture" action="/admin/ajaxUpload.do"
                    accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload">
            <a-button>
              <Icon icon="UploadOutlined"></Icon>
              上传
            </a-button>
          </a-upload>
        </a-form-item>
        <a-row>
          <a href="http://mall-cinema-base.oss-cn-guangzhou.aliyuncs.com/temp/%E5%AF%BC%E5%85%A5%E5%8D%A1%E5%BB%B6%E6%9C%9F%E4%BF%A1%E6%81%AF.xlsx">线上会员卡延期模板</a>
        </a-row>
        <a-row style="margin-top: 20px;justify-content: center;">
          <a-button @click="onBatchFileListUpload" type="primary">确定</a-button>
        </a-row>
      </a-form>
<!--      <a-tabs v-model:activeKey="batchDelayKey">-->
<!--        <a-tab-pane key="level" tab="卡等级批量延期">
          <a-form ref="batchDelayRef" name="batchDelayRef" @finish="onBatchDelayOk">
            <a-form-item class="ui-form__item" name="organizationId" label="影院组织">
              <a-select placeholder="请选择" v-model:value="formDelay.organizationId" style="width: 250px;"
                        @change="getAllCinemaList">
                <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                  {{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="ui-form__item" name="cinemaId" label="开卡影院">
              <a-select placeholder="请选择" v-model:value="formDelay.cinemaId" style="width: 250px;"
                        @change="getCardPolicyList">
                <a-select-option :value="0">全部</a-select-option>
                <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
                  {{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item name="cardId" label="卡等级" :rules="[{ required: true, message: '必选项不允许为空' }]">
              <a-select placeholder="请选择" v-model:value="formDelay.cardId" style="width: 300px;" mode="tags">
                <a-select-option v-for="item in cardAllList" :vlaue="item.id" :key="item.id"> {{ item.title }}</a-select-option>
              </a-select>
            </a-form-item>

            <a-row style="justify-content: center;">
              <a-button type="primary" html-type="submit">确定</a-button>
            </a-row>
          </a-form>
        </a-tab-pane>-->
<!--        <a-tab-pane key="file" tab="导入文件">

        </a-tab-pane>-->

<!--      </a-tabs>-->
    </a-modal>

    <a-modal v-model:visible="setSelectBatchDelayVisible" title="已选" width="850px" destroyOnClose @ok="onBatchDelayOk" @cancel="onBatchCancel">
      <a-spin :spinning="loading">
        <a-button style="margin-bottom: 20px;" @click="onDelay(null)">设置延期时间</a-button>
<!--        <a-button style="margin-bottom: 20px;">设置延期时间</a-button>-->

        <a-table :dataSource="selectedListData" :columns="selectedColumns" :pagination="false">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'expireDate'">
              {{ transDateTime(record.expireDate, 1) }}
            </template>
            <template v-else-if="column.key === 'newExpireDate'">
              <span v-if="delayModelRef.setValue && !setDelayVisible">{{ transDateTime(delayEndTime(record.expireDate), 1) }}</span>
            </template>
          </template>
        </a-table>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
	import {
		Icon
	} from '@/components/icon/icon.js';
	import exportComponent from '@/components/exportReport/exportReport.vue';
	import Recharge from './recharge.vue';
	import {
		getOrganizationList,
		getCinemaList
	} from '@/service/modules/cinema.js';
  import {
    getCardPolicyList,
    getCardInfoList,
    pullOnShelvesCardInfo,
    pullOffShelvesCardInfo,
    modifyBalance,
    cardUnbinding, updateCardCinema,
    cardBatchDelay, cardDelay, importDelay
  } from "@/service/modules/coupon.js";
  import {importCoupon} from "@/service/modules/import";
	export default {
		components: {
			Icon,
			exportComponent,
			Recharge
		},
		data() {
			return {
				loading: false,
				showAll: false,
				organizationList: [],
				cinemaAllList: [],
				cardAllList: [],
				formState: {
					type: 3,
					//organizationId: 0,
					cinemaId: 0,
					cardId: 0,
					status: 0,
          useCinemaId:'',
          isOneCard:'',
          cardTitle: '',
				},
				searchData: {},
				showRecord: false,
				id: 0,
				showModal: false,
				modifyItem: {},
				modelRef: {
          balance: 0,
          giftAmount: 0,
        },
				selectedRowKeys: [],
				selectedListData: [],
        endTime: [],
				list: [],
				columns: [{
					title: '开卡影院名称',
					dataIndex: 'cinemaName'
				}, {
					title: '卡等级',
					dataIndex: 'cardTitle'
				}, {
					title: '卡号',
					dataIndex: 'cardNumber'
				}, {
          title: '是否一卡通',
          key: 'isOneCard'
        },
          {
            title: '可用影院',
            key:'cinemaNames',
          }, {
					title: '本金余额',
					dataIndex: 'balance',
					width: 120
				},  {
					title: '赠送余额',
					dataIndex: 'giftBalance',
					width: 120
				}, {
					title: '会员信息',
					key: 'userInfo'
				}, {
					title: '状态',
					width: 100,
					key: 'isDisabled'
				}, {
					title: '绑定时间',
					key: "createTime",
					width: 200
				}, {
					title: '有效期',
					key: "expireTime",
					width: 200
				}, {
					title: '操作',
					key: 'action',
					fixed: 'right',
					width: 160
				}],
				pagination: {
					showSizeChanger: true,
					showQuickJumper: true,
					size: "middle",
					pageSizeOptions: ['10', '20', '50', '100', '500'],
					showTotal: (total) => {
						return "共 " + total + " 条";
					},
					total: 0,
					current: 1,
					pageSize: 10,
					onChange: (page) => {
						this.pagination.current = page;
						this.getData();
					},
					onShowSizeChange: (page, pageSize) => {
						this.pagination.current = 1;
						this.pagination.pageSize = pageSize;
						this.getData();
					}
				},
        currentCinema:{},
        cinemaModelRef:{
          appCardId:'',
          // cinemaId:''
        },
        setChangeCinema: false,
        editCinema:[],
        setDelayVisible: false,
        visible: false,
        delayId: 0,
        delayModelRef: {},
        setRecordData: {},
        // 批量延期
        setBatchDelayVisible: false,
        batchDelayKey: 'file',
        delayFileList: [],
        formDelay: {},
        setSelectBatchDelayVisible: false,
        selectedColumns: [{
          title: '开卡影院名称',
          dataIndex: 'cinemaName'
        }, {
          title: '卡等级',
          dataIndex: 'cardTitle'
        }, {
          title: '卡号',
          dataIndex: 'cardNumber'
        }, {
          title: '延期前有效期',
          key: 'expireDate'
        }, {
          title: '延期后有效期',
          key: 'newExpireDate'
        }],
			}
		},
		created() {
			this.getOrganizationList();
			//this.onSearch();
		},
		methods: {
			onBack() {
				this.showModal = false;
				this.showRecord = false;
			},
			onSearch() {
				this.pagination.current = 1;
				// //this.pagination.pageSize = 10;
				this.selectedListData = [];
				this.selectedRowKeys = [];
				this.searchData = JSON.parse(JSON.stringify(this.formState));
				if (this.searchData.isNeverExpire == -1) {
					this.searchData.isNeverExpire = undefined;
					this.time = [];
				}
				if (this.searchData.isNeverExpire === 1) {
					this.time = [];
				}
				this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId :
					undefined;
				this.searchData.cinemaId = this.searchData.cinemaId ? this.searchData.cinemaId : undefined;
				this.searchData.status = this.searchData.status ? this.searchData.status : undefined;
				this.searchData.cardId = this.searchData.cardId ? this.searchData.cardId : undefined;
        this.searchData.isOneCard = this.searchData.isOneCard !== '' ? this.searchData.isOneCard : undefined;
        this.searchData.useCinemaId = this.searchData.useCinemaId !== '' ? this.searchData.useCinemaId : undefined;
        if (this.endTime && this.endTime.length) {
					this.searchData.startTime = this.endTime[0].startOf('day').valueOf() / 1000;
					this.searchData.endTime = this.endTime[1].endOf('day').valueOf() / 1000;
				}
				this.getData();
			},
			reset() {
				this.time = [];
				this.$refs.form.resetFields();
				if (this.organizationList.length) {
					this.formState.organizationId = this.organizationList[0].id;
					this.getAllCinemaList(this.formState.organizationId);
				}
				this.onSearch();
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getCardInfoList({
						page: this.pagination.current,
						pageSize: this.pagination.pageSize,
						type: 3,
						...this.searchData
					})
					this.loading = false;
					if (ret.code === 200) {
						this.pagination.total = ret.data.totalCount;
						this.list = ret.data.list;
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getOrganizationList() {
				this.loading = true;
				try {
					let ret = await getOrganizationList({
						page: 1,
						pageSize: 999999
					});
					if (ret.code === 200) {
						this.organizationList = ret.data.list;
						if (this.organizationList.length) {
							this.formState.organizationId = this.organizationList[0].id;
							this.getAllCinemaList(this.formState.organizationId);
						}
						this.onSearch();
					} else {
						this.loading = false;
					}
				} catch(e) {
					this.loading = false;
				}
			},
			async getAllCinemaList(organizationId) {
				this.cinemaAllList = [];
				this.formState.cinemaId = 0;
				this.cardAllList = [];
				this.formState.cardId = 0;
				let ret = await getCinemaList({
					page: 1,
					pageSize: 999999,
					organizationId: organizationId ? organizationId : undefined
				})
				if (ret.code === 200) {
					// if (ret.data.list && ret.data.list.length) {
					// 	this.formState.cinemaId = ret.data.list[0].id;
					// 	this.getCardPolicyList(this.formState.cinemaId);
					// }
					this.cinemaAllList = ret.data.list;
				}
			},
      onChangeCinema(item) {
        // 更新卡片影院信息
        this.editCinema =[]

        this.setChangeCinema = true;
        this.currentCinema = item;
        this.cinemaModelRef.appCardId = item.appCardId;

        this.editCinema = this.cinemaAllList
      },
      async onChangeCinemaOk() {
        //修改开卡影院
        if (this.cinemaModelRef.cinemaId == ''){
          return this.$message.warn('请选择开卡影院');
        }
        this.loading = true;
        try {
          let ret = await updateCardCinema({
            cardId: this.cinemaModelRef.appCardId,
            cinemaId: this.cinemaModelRef.cinemaId
          })
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('修改开卡影院成功');
            // this.$refs.modifyForm.resetFields();
            this.setChangeCinema = false
            this.getData();
          }
        } catch (e) {
          this.loading = false;
        }
      },
			onDisabled(item) {
				this.$confirm({
					title: '提示',
					content: "确定" + (item.isDisabled === 0 ? '禁用' : '启用') + '此卡吗？',
					onOk: async () => {
						this.loading = true;
						try {
							let ret;
							if (item.isDisabled === 0) {
								ret = await pullOffShelvesCardInfo({
                  id: item.id,
                  useCinemaId:item.cinemaId,
                  isOneCard:item.cinemaId,
								})
							} else {
								ret = await pullOnShelvesCardInfo({
                  id: item.id,
                  useCinemaId:item.cinemaId,
                  isOneCard:item.cinemaId,
								})
							}
							this.loading = false;
							if (ret.code === 200) {
								this.$message.success('操作成功');
								this.getData();
							}
						} catch (e) {
							this.loading = false;
						}
					}
				})
			},
			onUnbind(record) {
				this.$confirm({
					title: '提示',
					content: '确定执行解绑操作吗？',
					onOk: async () => {
						this.loading = true;
						let ret = await cardUnbinding({
							userCardId: record.id
						})
						this.loading = false;
						if (ret.code === 200) {
							this.$message.success('解绑成功！');
							this.getData();
						}
					}
				})
			},
			onModifyBalance(record) {
				this.modifyItem = record;
				this.modelRef = {};
				this.showModal = true;
			},
			onModifyCancel() {
				this.$refs.modifyForm.resetFields();
				this.modifyItem = {};
				this.showModal = false;
			},
			onModifyOk() {
				this.$refs.modifyForm.validateFields().then(async () => {
					this.loading = true;
					try {
						let ret = await modifyBalance({
							id: this.modifyItem.id,
							balance: this.modelRef.balance,
              giftAmount: this.modelRef.giftAmount,
              // useCinemaId:this.modifyItem.cinemaId,
              // isOneCard:this.modifyItem.cinemaId,
						})
						this.loading = false;
						if (ret.code === 200) {
							this.$message.success('余额调整成功');
							this.$refs.modifyForm.resetFields();
							this.showModal = false;
							this.getData();
						}
					} catch (e) {
						this.loading = false;
					}
				})
			},
			onRecord(record) {
				this.id = record.id;
				this.showRecord = true;
			},
			onSelectChange(record, selected) {
				if (selected) {
					if (this.selectedRowKeys.length < 500) {
						this.selectedListData.push(JSON.parse(JSON.stringify(record)));
						this.selectedRowKeys.push(record.id);
					} else {
						this.$message.warn('最大可选择数据不允许大于500条');
					}
				} else {
					this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(record.id), 1);
					this.selectedListData = this.selectedListData.filter(item => {
						return item.id !== record.id;
					});
				}
			},
			onSelectAll(selected) {
				if (selected) {
					let showWain = true;
					this.list.forEach(item => {
						if (this.selectedRowKeys.length < 500) {
							if (this.selectedRowKeys.indexOf(item.id) === -1 && item.status != 7 && item
								.isNeverExpire != 1 && item.usableTotal) {
								this.selectedListData.push(JSON.parse(JSON.stringify(item)));
								this.selectedRowKeys.push(item.id);
							}
						} else {
							if (showWain) {
								showWain = false;
								this.$message.warn('最大可选择数据不允许大于500条');
							}
						}
					})
				} else {
					this.list.forEach(item => {
						if (this.selectedRowKeys.indexOf(item.id) !== -1) {
							this.selectedListData.splice(this.selectedRowKeys.indexOf(item.id), 1);
							this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(item.id), 1);
						}
					})
				}
			},
			getCheckboxProps(record) {
				return {
          disabled: record.isNeverExpire,
					// disabled: (record.status === 7 || record.isNeverExpire === 1 || !record.usableTotal),
					id: record.id.toString()
				}
			},
			disabledDate(current) {
				return current && current < this.moment().endOf('day');
			},
      onCardDelay(record) {
        if (record) {
          this.selectedRowKeys = [];
          this.selectedListData = [];
        }
        // this.setRecordData = record;
        this.setRecordData = JSON.parse(JSON.stringify(record));
        if (!this.setRecordData.expireDate) {
          this.setRecordData.lossExpireDate = true;
          this.setRecordData.expireDate = this.moment().unix();
        }
        this.setDelayVisible = !this.setDelayVisible;
      },
      onDelayOk() {
        this.$refs.delayForm.validateFields().then(async () => {
          if (!this.setSelectBatchDelayVisible) {
            this.loading = true;
            try {
              let ret = await cardDelay({
                id: this.setRecordData.appCardId,
                delayTime: parseInt(this.delayEndTime(this.setRecordData.expireDate) /
                  1000)
              });
              this.loading = false;
              if (ret.code === 200) {
                this.setRecordData = {};
                this.$message.success('操作成功');
                this.setDelayVisible = false;
                this.getData();
              }
            } catch (e) {
              this.loading = false;
            }
          } else {
            this.setDelayVisible = false;
          }
        })
      },
      async getCardPolicyList(cinemaId) {
        this.cardAllList = [];
        this.formState.cardId = 0;
        if (!cinemaId) return;
        let ret = await getCardPolicyList({
          page: 1,
          pageSize: 999999,
          type: 3,
          useCinemaId: this.formDelay.cinemaId ? this.formDelay.cinemaId : undefined
        })
        if (ret.code === 200) {
          this.cardAllList = ret.data.list;
        }
      },
      onDelayCancel() {
        this.delayModelRef = {};
        this.setDelayVisible = false;
      },
      onBatchCancel() {
        this.delayModelRef = {};
        this.setDelayVisible = false;
      },
      delayEndTime(expireDate) {
        //  延期时间处理
        if (!expireDate) return '';
        if ((expireDate + '').length === 10) {
          expireDate = expireDate * 1000;
        }
        if (this.delayModelRef.setValue === 1) {
          return this.moment(expireDate).add(1, 'day').endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 2) {
          return this.moment(expireDate).add(7, 'day').endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 3) {
          return this.moment(expireDate).add(3, 'month').endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 4) {
          return this.moment(expireDate).add(6, 'month').endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 5) {
          return this.moment(expireDate).add(12, 'month').endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 6) {
          return this.delayModelRef.specifiesTime.endOf('day').valueOf();
        } else if (this.delayModelRef.setValue === 7) {
          if (this.delayModelRef.delayDays) {
            return this.moment(expireDate).add(this.delayModelRef.delayDays, 'day').endOf('day').valueOf();
          } else {
            return this.moment(expireDate).endOf('day').valueOf();
          }
        } else {
          return this.moment(expireDate).endOf('day').valueOf();
        }
      },
      onBatchDelay() {
        this.setBatchDelayVisible = true;
      },
      async onBatchDelayOk() {
        if (!this.delayModelRef.setValue) {
          return this.$message.warn('请设置延期时间');
        }
        const appCards = this.selectedListData.map(item => {
          return {
            id: item.appCardId,
            delayTime: parseInt(this.delayEndTime(item.expireDate) / 1000)
          }
        });
        this.loading = true;
        try {
          const ret = await cardBatchDelay({appCards});
          if (ret.code == 200) {
            this.getData();
            this.$message.success('操作成功');
            this.delayModelRef = {};
            this.selectedRowKeys = [];
            this.selectedListData = [];
            this.setDelayVisible = false;
            this.setSelectBatchDelayVisible = false;
          }
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      },
      onBatchDelayCancel() {
        this.delayModelRef = {};
        this.visible = false;
      },
      async onBatchFileListUpload() {
        if (this.delayFileList.length === 0) {
          return this.$message.warn('请上传文件');
        }
        const isLt5M = this.delayFileList[0].size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        this.loading = true;
        try {
          let ret = await importDelay({}, this.delayFileList[0]);
          this.loading = false;
          if (ret.code === 200) {
            this.$message.success('导入成功,');
            this.delayFileList = [];
          } else {
            this.delayFileList = [];
          }
        } catch(e) {
          this.loading = false;
        }
      },
      beforeUpload(file) {
        const isLt1M = file.size / 1024 / 1024 < 5;
        if (!isLt1M) {
          this.$message.error('上传文件太大了, 最大只允许5M');
        }
        return false;
      },
      onSelectBatchDelay() {
        this.setSelectBatchDelayVisible = true;

      },
      onDelay(item) {
        this.setRecordData = item;
        this.setDelayVisible = !this.setDelayVisible;
      },
		}
	}
</script>

<style scoped>
	.ui-form__item {
		margin-right: 30px;
	}
</style>
